<template>

</template>

<script>
import firebase from "firebase";

export default {
  name: "Logout",
  created() {

  }
}
</script>

<style scoped>

</style>